import React, { useEffect, useRef, useState } from "react";
import { GET_ALL_GAMES_RESULT } from "../../service/admin.service";
import Navbar from "../../Pages/Navbar/Navbar";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Footer from "../../Pages/Footer/Footer";

import stars from "../../../RichImages/stars.svg";
import back from "../../../RichImages/back.svg";
import MayaMorning from "../../Charts/PanaCharts/MayaMorning";
import INDRADAY from "../../Charts/PanaCharts/INDRADAY";
import INDRANIGHT from "../../Charts/PanaCharts/INDRANIGHT";
import MAYADAY from "../../Charts/PanaCharts/MAYADAY";
import MAYANIGHT from "../../Charts/PanaCharts/MAYANIGHT";

import DHARMNIGHT from "../../Charts/PanaCharts/DHARMNIGHT";
import DHARMDAY from "../../Charts/PanaCharts/DHARMDAY";
import DHARMMORNING from "../../Charts/PanaCharts/DHARMMORNING";

import YUGNIGHT from "../../Charts/PanaCharts/YUGNIGHT";
import YUGDAY from "../../Charts/PanaCharts/YUGDAY";
import YUGMORNING from "../../Charts/PanaCharts/YUGMORNING";

import VEDANIGHT from "../../Charts/PanaCharts/VEDANIGHT";
import VEDADAY from "../../Charts/PanaCharts/VEDADAY";
import VEDAMORNING from "../../Charts/PanaCharts/VEDAMORNING";
import RADHAMORNING from "../../Charts/PanaCharts/RADHAMORNING";
import SHRIMORNING from "../../Charts/PanaCharts/SHRIMORNING";
import RAMAMORNING from "../../Charts/PanaCharts/RAMAMORNING";
import RADHADAY from "../../Charts/PanaCharts/RADHADAY";
import SHRIDAY from "../../Charts/PanaCharts/SHRIDAY";
import RAMADAY from "../../Charts/PanaCharts/RAMADAY";
import RADHANIGHT from "../../Charts/PanaCharts/RADHANIGHT";
import SHRINIGHT from "../../Charts/PanaCharts/SHRINIGHT";
import RAMANIGHT from "../../Charts/PanaCharts/RAMANIGHT";
import { GetAllCharts } from "../../Helpers/GetCharts";
import { common_chart_url } from "../../Config/config";

const Pana_Chart = () => {
  const navigate = useNavigate();
  const { title } = useParams();
  const location = useLocation();
  const [getData, setgetData] = useState([]);
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState("0px");
  const [isIframeLoading, setIsIframeLoading] = useState(true);

  const handleClick = () => {
    const targetElement = document.getElementById("scroll-down");

    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
    }
  };

  const normalize = (str) =>
    str?.replace(/-/g, "").replace(/\s+/g, "").toUpperCase();

  const normalizedTitle = normalize(title);

  const getResponseData = async () => {
    const req = location.state;

    // const res = await GET_ALL_GAMES_RESULT({ id: req });
    const res = await GetAllCharts(GET_ALL_GAMES_RESULT, req);
    setgetData(res);
  };

  useEffect(() => {
    if (title) getResponseData();
  }, [title]);

  const chartMap = {
    // Maya
    MAYAMORNING: MayaMorning,
    MAYANIGHT: MAYANIGHT,
    MAYADAY: MAYADAY,

    // Indra
    // INDRAMORNING: INDRAMORNING,
    INDRANIGHT: INDRANIGHT,
    INDRADAY: INDRADAY,

    // Ved
    VEDAMORNING: VEDAMORNING,
    VEDANIGHT: VEDANIGHT,
    VEDADAY: VEDADAY,

    // Yug
    YUGMORNING: YUGMORNING,
    YUGDAY: YUGDAY,
    YUGNIGHT: YUGNIGHT,

    // Dharm
    DHARMMORNING: DHARMMORNING,
    DHARMDAY: DHARMDAY,
    DHARMNIGHT: DHARMNIGHT,

    // Radha / Shri / Rama group
    RADHAMORNING: RADHAMORNING,
    SHRIMORNING: SHRIMORNING,
    RAMAMORNING: RAMAMORNING,

    RADHADAY: RADHADAY,
    SHRIDAY: SHRIDAY,
    RAMADAY: RAMADAY,

    RADHANIGHT: RADHANIGHT,
    SHRINIGHT: SHRINIGHT,
    RAMANIGHT: RAMANIGHT,
  };

  const ChartComponent = chartMap[normalizedTitle];

  // iframe fallback (TITLE BASED)
  const chartUrl = `${common_chart_url}pana-chart/${normalizedTitle}?embed=true&color=%23478767`;

  // iframe height listener
  useEffect(() => {
    if (ChartComponent) return;

    const handleMessage = (event) => {
      if (event.data?.type === "SET_HEIGHT") {
        const newHeight = `${event.data.height}px`;
        setIframeHeight(newHeight);
        if (iframeRef.current) {
          iframeRef.current.style.height = newHeight;
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [ChartComponent]);

  return (
    <>
      <div id="scroll-up"></div>
      <Navbar />

      <div className="container-fluid">
        <div className="row">
          <div className="text-center col-xl-12 col-q-12 col-md-12 col-sm-12 chart-header ">
            <div className="">
              <div className="d-flex justify-content-center align-items-center">
                <div className="backgroundoftitle">
                  <img
                    className="game-icons-img"
                    src={stars}
                    alt="https://radha567.com/"
                  />
                  <h1 class="mb-0 ms-2 me-2 rich-game-title backgroundoftitle">
                    {normalizedTitle}
                  </h1>
                  <img
                    className="game-icons-img"
                    src={stars}
                    alt="https://radha567.com/"
                  />
                </div>
              </div>

              <p style={{ fontWeight: 600, marginTop: "10px" }}>
                Explore {normalizedTitle} Pana Chart with old result history,
                complete digit records, and live updates all available in one
                place.
              </p>
            </div>

            <button
              class="download-button"
              style={{ paddingLeft: "35px", paddingRight: "35px" }}
              onClick={handleClick}
              id="scroll-down-button"
            >
              Go To Bottom&nbsp;
              <svg
                width="16"
                height="11"
                viewBox="0 0 16 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.8188 0.409424L8 6.22817L2.18125 0.409424L0 2.59067L8 10.5907L16 2.59067L13.8188 0.409424Z"
                  fill="white"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <div className="">
        <div className="row justify-content-center">
          <div className="p-0 text-center d-flex justify-content-center   col-xl-12 col-q-12 col-md-12 col-sm-12">
            <div className="table-responsive  text-center col-xl-8 col-lg-12 col-md-12 col-sm-12">
              {ChartComponent ? (
                <ChartComponent chartData={getData.data} />
              ) : (
                <div
                  style={{
                    minHeight: iframeHeight === "0px" ? "150px" : iframeHeight,
                    position: "relative",
                  }}
                >
                  {/* Skeleton Loader */}
                  {isIframeLoading && (
                    <div
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        padding: "20px",
                        background: "#fff",
                        zIndex: 10,
                      }}
                    >
                      <div className="skeleton-box"></div>
                      <div className="skeleton-box"></div>
                      <div className="skeleton-box"></div>
                    </div>
                  )}

                  {/* iframe */}
                  <iframe
                    ref={iframeRef}
                    src={chartUrl}
                    title="Charts"
                    onLoad={() => setIsIframeLoading(false)}
                    className="w-100 border-0 transition-all duration-500"
                    scrolling="no"
                    style={{
                      width: "100%",
                      height: iframeHeight,
                      opacity: isIframeLoading ? 0 : 1,
                    }}
                  />
                </div>
              )}
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <button
              class="download-button"
              style={{
                paddingLeft: "35px",
                paddingRight: "35px",
                marginTop: "10px",
              }}
              onClick={() => navigate(-1)}
              id="scroll-down-button"
            >
              Back &nbsp;
              <img
                style={{ width: "10px" }}
                src={back}
                alt="https://radha567.com/"
              />
            </button>
          </div>
        </div>
      </div>

      <Footer />
      <div id="scroll-down"></div>
    </>
  );
};

export default Pana_Chart;
